import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { FmSystemListResponse } from "../_model/fmSystemList-response/fmSystemList-response";
import { UserService } from "./user.service";

@Injectable({
  providedIn: 'root'
})
export class FmSystemListService {

  baseUrl = '/fmSystemList';

  constructor(private http: HttpClient, private userService: UserService) {
  }

  getFmSystemLists(): Observable<FmSystemListResponse> {
    return this.http.get<FmSystemListResponse>(this.userService.getBaseUrl() + this.baseUrl);
  }

  getFmSystemByBrands(brand: string): Observable<FmSystemListResponse> {
    return this.http.get<FmSystemListResponse>(this.userService.getBaseUrl() + '/fmSystems' + '/brand' + '/' + brand);
  }

  getFmSystemByDefaultBrands(): Observable<FmSystemListResponse> {
    return this.http.get<FmSystemListResponse>(this.userService.getBaseUrl() + '/fmSystems' + '/brand' + '/' + this.userService.getBrand());
  }
}
